// import { gsap } from 'gsap';
// import { ScrollTrigger } from 'gsap/ScrollTrigger';
// import { MotionPathPlugin } from 'gsap/MotionPathPlugin';

gsap.registerPlugin(ScrollTrigger, MotionPathPlugin);

const arrowEl = document.querySelector('.text-sec__arrow-wr');
if (arrowEl && window.innerWidth > 1024) {
  gsap.to('#motionSVG-2', {
    scrollTrigger: {
      trigger: '#motionSVG-2',
      start: '150px 70%',
      end: '+=400px',
      scrub: 1,
      // markers: true,
      onUpdate: (self) => {
        gsap.to('#motionSVG-2', {
          opacity: self.progress,
        });
        if (self.progress < 0.15) {
          arrowEl.classList.add('is-hidden');
        } else {
          arrowEl.classList.remove('is-hidden');
        }
      },
    },
    duration: 10,
    ease: 'none',
    immediateRender: true,
    scale: 0.5,
    motionPath: {
      path: '#motionPath-2',
      align: '#motionPath-2',
      alignOrigin: [0.5, 0.5],
      autoRotate: true,
      start: 1,
      end: 0,
    },
  });
}
